import type { BenchmarkSelection, ModelView, QualifiedModelScore } from "./contracts.ts";

/** Sole accessor for a model's selected benchmark observation. */
export function resolveModelScore(
  model: ModelView,
  selection: BenchmarkSelection,
): QualifiedModelScore | null {
  if (selection.source === "epoch-eci") {
    const score = model.epochEciScores?.[selection.metric];
    return score && Number.isFinite(score.value) ? score : null;
  }

  const value = model[selection.metric];
  if (typeof value !== "number" || !Number.isFinite(value)) return null;
  return {
    source: "artificial-analysis",
    metric: selection.metric,
    value,
    // AA supplements/variant proxies publish a score triple. The model-level
    // provenance flag therefore applies to Coding and Agentic as well as the
    // headline Intelligence value; consumers must not render sibling metrics
    // as measured merely because a different metric was selected.
    estimated: model.intelligenceIndexEstimated,
    interval: { status: "unavailable", reason: "Artificial Analysis does not publish a 90% ECI interval for this score." },
    sourceLabel: model.intelligenceSourceLabel ?? "Artificial Analysis",
    sourceUrl: model.intelligenceSourceUrl ?? "https://artificialanalysis.ai/",
    observedAt: model.scoreObservedAt,
  };
}
